import React from "react";
import { CetelemProvider } from './../Providers/CetelemProvider.js'

export default class CetelemCalculator extends React.Component {
	constructor(props) {
		super(props);
		this.defaultBarem = "184";
		this.defaultInsurance = "T2";
		this.defaultNumRePayments = 10;

		this.state = {
			show: false,
			data: null,
			barems: null,
			insurances: null
		};

	}

	handleChangeData = (name, e) => {
		var data = this.state.data;
		data[name] = e.target.value;
		this.setState({ data: data });
	}

	handleClickShow = (e) => {
		e.preventDefault();
		this.setState({ show: true }, this.load());
	}

	load = () => {
		if (!this.state.barems) {
			CetelemProvider.loadBarems((data) => {
				this.setState({ barems: data });
			})
		}
		if (!this.state.insurances) {
			CetelemProvider.loadInsuarences((data) => {
				this.setState({ insurances: data });
			})
		}
		let data = this.state.data;
		if (data == null) {
			data = {
				barem: this.defaultBarem,
				insurance: this.defaultInsurance,
				price: this.props.price,
				numRePayments: this.defaultNumRePayments			
			}
		}
		CetelemProvider.calculate(data, (result) => {
			if (result.result) {
				this.setState({ data: result });
			}
			else {
				this.setState({ data: data });
			}
		})
	}

	handleRecalculate = (e) => {
		this.load();
	}

	render = () => {
		var data = this.state.data;
		return <>
		<span>Nákup na splátky: </span>
			<a href="#" data-toggle="modal" data-target="#CetelemModal" onClick={(e) => this.handleClickShow(e)}  >kalkulace Cetelem</a>
			{this.state.show && this.state.data && this.state.insurances && this.state.barems ?

				<div className="modal fade in" tabIndex="-1" id="CetelemModal" role="dialog" style={{ display: 'block', paddingRight: '16px', overflowX: 'hidden', overflowY: 'auto' }}>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-body">
								<div style={{ height: '500px', width: '100%', overflowY: 'auto' }}>
									<div id="CetelemCalculatorFrame">
										<div>
											<h3>Výpočet splátek Hello bank by Cetelem</h3>
											{(data.result) ? <p /> : <p><span style={{ textAlign: 'center', color: 'red' }}>{data.error}</span></p>
											}
											<table className="cetelem-table table">
												<tbody><tr className="bacground">
													<td className="text">Cena zboží:</td>
													<td className="value cena">{this.props.price}</td>
												</tr>
													<tr>
														<td className="text">Vyberte si typ půjčky:</td>
														<td className="value">
															<select name="kodBaremu" id="_kodBaremu" onChange={(e) => this.handleChangeData('barem', e)}>
																{this.state.barems.map((item) => {
																	return (<option selected={item.id == data.barem} value={item.id}>{item.name}</option>);
																})}
															</select>
														</td>
													</tr>
													<tr className="bacground">
														<td className="text">Pojištění:</td>
														<td className="value">
															<select name="kodPojisteni" onChange={(e) => this.handleChangeData('insurance', e)}>
																{this.state.insurances.map((item) => {
																	return (<option selected={item.name == data.insurance} value={item.name} >{item.value}</option>);
																})}
															</select>
														</td>
													</tr>
													<tr>
														<td className="text">Přímá platba:</td>
														<td className="value"><input name="primaPlatba" type="text" id="primaPlatba" className="input" value={data.directPayment} onChange={(e) => this.handleChangeData('directPayment', e)} /> </td>
													</tr>
													<tr className="bacground">
														<td className="text">Počet splátek:</td>
														<td className="value"><input name="pocetSplatek" type="text" id="pocetSplatek" className="input" value={data.numRePayments} onChange={(e) => this.handleChangeData('numRePayments', e)} /> </td>
													</tr>
													<tr>
														<td className="text">Odklad (měsíců):</td>
														<td className="value"><input name="odklad" type="text" id="odklad" className="input" value={data.suspension} onChange={(e) => this.handleChangeData('suspension', e)} /> </td>
													</tr>


													<tr className="bacground">
														<td className="text repaymentamount">Celková výše splátky:</td>
														<td className="value repaymentamount"> <span>{data.totalPrice + ' Kč'}</span> (včetně pojištění, má-li být sjednáno)</td>
													</tr>
													<tr className="bacground">
														<td className="text repaymentamount">Výše splátky:</td>
														<td className="value repaymentamount"> <span>{data.repaymentAmount + ' Kč'}</span> </td>
													</tr>
													<tr>
														<td className="text creditprice"> </td>
														<td className="value creditprice"> </td>
													</tr>
													<tr className="bacground">
														<td className="text">Cena úvěru:</td>
														<td className="value"> <span>{data.creditPrice + ' Kč'}</span> (včetně pojištění, má-li být sjednáno)</td>
													</tr>
													<tr>
														<td className="text loanamount">Výše úvěru:</td>
														<td className="value loanamount"> <span>{data.loanAmount + ' Kč'}</span> </td>
													</tr>
													<tr className="bacground">
														<td className="text ursaz">Úroková sazba:</td>
														<td className="value ursaz">  <span>{(data.ursaz)? data.ursaz.toFixed(2) + ' %' :''}</span> </td>
													</tr>
													<tr>
														<td className="text rpsn">RPSN:</td>
														<td className="value rpsn"> <span>{(data.rpsn) ? data.rpsn.toFixed(2) + ' %':''}</span></td>
													</tr>
													<tr className="bacground">
														<td className="text totalprice">Celková splacená částka:</td>
														<td className="value totalprice"> <span>{data.totalPrice + ' Kč'}</span></td>
													</tr>
												</tbody>
											</table>
											<div className="CetelemBarems">
												{this.state.barems.map((item) => {
													return (<div className="Barem">
														<p className="name">{item.name}</p>
														<p className="info">
															{item.infos.map((info) => {
																return (
																	<>{info}<br /></>
																);
															})}
														</p>
													</div>);
												})}
											</div>

										</div>
									</div>

								</div>
							</div>
							<div className="modal-footer">

								<button style={{ float: 'left', marginLeft: '10px' }} className="cetelem-prepocitat btn" onClick={(e) => this.handleRecalculate(e)}>Přepočítat</button>
								<button type="button" className="btn btn-default" data-dismiss="modal" onClick={(e) => { this.setState({ show: false }); }}>Zavřít</button>
							</div>
						</div>
					</div>
				</div> : null}
		</>
	}
}

var element = document.getElementById("app-cetelemcalculator");
if (element) {
	var price = element.getAttribute('data-price');
	ReactDOM.render(<CetelemCalculator price={price} />, element);
}
